import React from 'react';
import { Layers, Server, PieChart } from 'lucide-react';

const ProjectBasicsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  projectTypes,
  blockchainPlatforms,
  projectSizes
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      {/* Тип проекта */}
      <div>
        <label htmlFor="projectType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Layers className="w-4 h-4 mr-2 text-indigo-500" />
          Тип проекта
        </label>
        <select
          id="projectType"
          name="projectType"
          value={formData.projectType}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.projectType ? 'input-error' : ''}`}
        >
          {projectTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {errors.projectType && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.projectType}
          </p>
        )}
      </div>

      {/* Блокчейн-платформа */}
      <div>
        <label htmlFor="blockchainPlatform" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <Server className="w-4 h-4 mr-2 text-indigo-500" />
          Блокчейн-платформа
        </label>
        <select
          id="blockchainPlatform"
          name="blockchainPlatform"
          value={formData.blockchainPlatform}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.blockchainPlatform ? 'input-error' : ''}`}
        >
          {blockchainPlatforms.map((platform) => (
            <option key={platform.id} value={platform.id}>
              {platform.name} ({platform.language})
            </option>
          ))}
        </select>
        {errors.blockchainPlatform && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.blockchainPlatform}
          </p>
        )}
      </div>

      {/* Размер проекта */}
      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2 flex items-center">
          <PieChart className="w-4 h-4 mr-2 text-indigo-500" />
          Размер проекта
        </label>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          {projectSizes.map((size) => (
            <div key={size.id}>
              <label className="flex items-start p-3 bg-white dark:bg-gray-800 border rounded-lg cursor-pointer transition-colors h-full
                                 hover:bg-gray-50 dark:hover:bg-gray-700
                                 ${formData.projectSize === size.id ? 'border-indigo-500 dark:border-indigo-400 bg-indigo-50 dark:bg-indigo-900/30' : 'border-gray-200 dark:border-gray-700'}">
                <input
                  type="radio"
                  name="projectSize"
                  value={size.id}
                  checked={formData.projectSize === size.id}
                  onChange={handleInputChange}
                  className="form-radio mt-0.5"
                />
                <div className="ml-2">
                  <span className="block text-sm font-medium text-gray-900 dark:text-white">
                    {size.name}
                  </span>
                  <span className="text-xs text-gray-500 dark:text-gray-400">
                    {size.description}
                  </span>
                </div>
              </label>
            </div>
          ))}
        </div>
        {errors.projectSize && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.projectSize}
          </p>
        )}
      </div>

      {/* Кастомный токен */}
      <div className="col-span-full mt-3">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="customTokenRequired"
            checked={formData.customTokenRequired}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Требуется разработка собственного токена/криптовалюты
          </span>
        </label>
      </div>
    </div>
  );
};

export default ProjectBasicsSection;